
import { useEffect } from 'react';
import { MonitoringEventType } from '@/types/monitoring';

type MonitoringEventLogger = (event: {
  id?: string;
  event_type: MonitoringEventType;
  event_data: any;
  severity: number;
  duration?: number;
  device_fingerprint?: string;
  question_id?: string;
  ai_confidence_score?: number;
  created_at: string;
}) => void;

export const useClipboardMonitoring = (
  logEvent: MonitoringEventLogger,
  currentQuestionId?: string
) => {
  useEffect(() => {
    const handleClipboardAction = (event: ClipboardEvent) => {
      const actionType = event.type;
      const id = crypto.randomUUID();
      
      logEvent({
        id,
        event_type: 'clipboard_action',
        event_data: {
          action: actionType,
          targetTagName: (event.target as HTMLElement)?.tagName,
          timestamp: new Date().toISOString(),
        },
        severity: 2, // Medium severity
        created_at: new Date().toISOString(),
        question_id: currentQuestionId,
      });
      
      console.log(`[Monitoring] Clipboard action detected: ${actionType}`);
    };

    document.addEventListener('copy', handleClipboardAction);
    document.addEventListener('paste', handleClipboardAction);
    document.addEventListener('cut', handleClipboardAction);

    return () => {
      document.removeEventListener('copy', handleClipboardAction);
      document.removeEventListener('paste', handleClipboardAction);
      document.removeEventListener('cut', handleClipboardAction);
    };
  }, [logEvent, currentQuestionId]);
};
